import {useEffect} from "react";
import {useHistory} from "react-router-dom";
import useCookieConsent from "../../hooks/useCookieConsent";
import {
    removeGoogleAnalyticsCookies,
    setGoogleAnalyticsDisabled,
} from "../../utils/CookieConsentUtils";
import {sendAnalyticsPageView} from "../../utils/GoogleAnalyticsUtils";

export default function GoogleAnalytics() {
    const history = useHistory();
    const {analytics} = useCookieConsent();

    useEffect(() => {
        if (!analytics) {
            setGoogleAnalyticsDisabled(true);
            removeGoogleAnalyticsCookies();
            return undefined;
        }

        sendAnalyticsPageView(
            `${history.location.pathname}${history.location.search}`
        );
        return history.listen((location) => {
            sendAnalyticsPageView(`${location.pathname}${location.search}`);
        });
    }, [analytics, history]);

    return null;
}
